import { Duration, format, isDate, parse } from 'date-fns';

export const formatDateString = (dateString: string) => {
    try {
        if (isDate(new Date(dateString))) {
            const locale = navigator.language;
            const parsedDate = parse(dateString, 'yyyyMMdd', new Date());
            return format(
                parsedDate,
                locale === 'en-US' ? 'MM/dd/yyyy' : 'dd/MM/yyyy'
            );
        }
    } catch (error) {
        return undefined;
    }
};

export function formatDate(dateString: string) {
    try {
        if (dateString) {
            return parse(dateString, 'yyyyMMdd', new Date());
        } else return undefined;
    } catch (error) {
        return undefined;
    }
}

/**
 * Formats a date-fns Duration object into a time string (mm:ss or HH:mm:ss).
 * @param duration - The Duration object from date-fns.
 * @returns A formatted time string.
 */
export const formatDurationTime = (duration: Duration): string => {
    const date = new Date(0);
    date.setHours(duration.hours || 0);
    date.setMinutes(duration.minutes || 0);
    date.setSeconds(duration.seconds || 0);

    const formatString = (duration.hours || 0) > 0 ? 'HH:mm:ss' : 'mm:ss';
    return format(date, formatString);
};
